<template>
  <FaIcon :icon="['fal', ICON.EXPAND]" />
</template>

<script setup lang="ts">
import { ICON } from '@/constants/icons';
</script>

